<div class="alert-container WARNING m-t-20">
  <div class="icon">
    <span class="material-symbols-outlined"> info </span>
  </div>

  <div class="bx-content">
    <div class="content">
      <p class="h5">Log In to Continue</p>

      <p>Please log in to your account to verify your information and continue with your request.</p>

      <button type="button" class="btn btn-primary m-t-8 btn-login" (click)="loginHandler()">LOG IN</button>
    </div>
  </div>
</div>
